import { Pipe, PipeTransform } from '@angular/core';
import { Customer } from '../../models';

@Pipe({
    name: 'customerAddress',
    standalone: true
})
export class CustomerAddressPipe implements PipeTransform {
  validAddressFields = [
    'address_1',
    'address_2',
    'city',
    'county',
    'country',
    'post_code'
  ];
  transform(value: Customer, lineJoins = ', '): any {
    let address = [];
    this.validAddressFields.forEach((field) => {
      if (value[field]) {
        address.push(value[field]);
      }
    });
    return address.join(lineJoins);
  }
}
